import All4Indoor from './All4Indoor';

function App() {
  return <All4Indoor />;
}

export default App;
